const it = {
  login: {
    title: "Sistema di invio dati",
    email: "Email",
    password: "Password",
    forgotPassword: "Password dimenticata",
    logout: "Logout",
    inEmail: "Email non valida",
    loginfailed: "Accesso fallito, email o password errati",
    enterEmail: "Inserisci la tua email",
    enterPassword: "Inserisci la tua password",
    enterCode: "Inserisci il codice di verifica",
    passwordNotMatch: "Le password non corrispondono",
  },
  forgot: {
    forgotPassword: "Password dimenticata",
    tip: "Ti invieremo un codice di verifica al tuo indirizzo email",
    email: "Email",
    code: "Codice di verifica",
    password: "Password",
    confirmPassword: "Conferma password",
    send: "Invia",
    submit: "Invia",
    login: "Login",
  },
  menu: {
    mange: "Gestione dei moduli",
    mangeTip: "Creazione dei moduli di invio dati, visualizzazione dei dati",
    submission: "Compila il modulo",
    account: "Gestione account",
    uwell: "Account interno",
    external: "Account esterno",
  },
  editList: {
    fill: "Compila",
    record: "Dati",
    createdTime: "Data di creazione",
    formTitle: "Nome del modulo",
    titleTip: "Inserisci un titolo",
    showInput: "Mostra i moduli da compilare e i record di compilazione",
  },
  editFill: {
    save: "Salvare",
    nosave:'Non salvare',
    backSaveTip:'Vuoi salvare il contenuto inserito?',
    submitted:'inviato',
    notsubmitted:'non inviato',

    submit: "Invia",
    submitSuccess: "Invio effettuato con successo",
    fillAgain: "Compila nuovamente",
    invalid: "Parametro non valido",
    noTime: "Il modulo non è disponibile al momento",
    failedStop: "Invio fallito, il modulo non accetta più dati",
    failedNot: "Invio fallito, il modulo non esiste",
    failedPassed:
      "Invio fallito, il modulo può essere compilato solo una volta",
    failedOnce:
      "Invio fallito, il modulo può essere compilato solo una volta al giorno",
    noempty: "I campi obbligatori non possono essere vuoti",
  },
  editInfo: {
    SubmitTime: "Data di invio",
    submitter:'Mittente',
    search: "Cerca",
    clear: "Resetta",
    filter: "Filtra",
    fieldSetting: "Gestione campi",
    export: "Esporta",
    createBy: "Creato da",
    updateTime: "Data di aggiornamento",
    status:'stato',
    action: "Azione",
    detail: "Dettagli",
    edit: "Modifica",
    more:"Di più",
    copy:"Copia",
    startDate: "Data di inizio",
    endDate: "Data di fine",
    selectAll: "Seleziona tutto",
    confirm: "Conferma",
    cancel: "Annulla",
    addFilter: "Aggiungi criterio di filtraggio",
    pleaseSelect: "Seleziona",
    pleaseFillIn: "Si prega di compilare",
    delete: "Elimina",
    filterIncom:
      "Il criterio di filtraggio della riga {num} non è completo, controlla",
    noData: "Nessun dato disponibile",
    uploadfailed: "Caricamento fallito",
    total: "Totale: {num} elementi",

    deleteTip: 'Questa operazione cancellerà i dati. Vuoi continuare?',
    deleteSuccess: 'Cancellazione avvenuta con successo'
  },
  fillIn: {
    equal: "Uguale a",
    noequal: "Diverso da",
    contains: "Contiene",
    notcontains: "Non contiene",
    empty: "Vuoto",
    notempty: "Non vuoto",
    before: "Prima di",
    after: "Dopo",
    greaterequal: "Maggiore o uguale a",
    lessequal: "Minore o uguale a",
    greaterthan: "Maggiore di",
    lessthan: "Minore di",
  },
  editEye: {
    detail: "Dati del modulo",
  },
  editUpdate: {
    editForm: "Modifica modulo",
    returnList: "Torna alla lista",
  },
};

export default it;
